import { Divider as AntdDivider } from 'antd';
import styled from 'styled-components';
import { ProductiveHeading06 } from 'components/styles';

export const Heading = styled.p<{ noMargin?: boolean }>`
  ${ProductiveHeading06};
  margin-bottom: var(--spacing-02);
`;

export const Divider = styled(AntdDivider)`
  margin-bottom: 0px;
`;
